import { Appointment, QUEUE_CONFIG_COLUMN_ID } from "@elixir/types";
import { QUEUE_TYPE } from "../../constants/appointments";
import useQueueStore from "../../stores/queue-store";
import useGetViewActions from "../../hooks/use-get-view-actions";
import QueueCardAction from "../../molecules/chips/queue/queue-card-action";

export const DEFAULT_COLUMNS = [
  "TAGS",
  "VITY",
  "PAYS",
] as QUEUE_CONFIG_COLUMN_ID[];

const ShowConfigSelectedColumns = ({
  apt,
  queueType,
}: {
  apt: Appointment;
  queueType: QUEUE_TYPE | string;
}) => {
  const rightPanelQueueType = useQueueStore(
    (state) => state.rightPanelQueueType
  );

  const [, activeViewColumns] = useGetViewActions({
    rowIdx: 0,
    apt,
  });

  const viewType = useQueueStore((state) => state.viewType);
  const openLeftPanel = useQueueStore((state) => state.openLeftPanel);

  let columnConfig = activeViewColumns;

  if (viewType === "compact") {
    if (openLeftPanel) {
      columnConfig = columnConfig.filter((_, idx) => idx < 1);
    } else {
      columnConfig = columnConfig.filter((_, idx) => idx < 3);
    }
  }

  return (
    <div className="dr-flex dr-flex-row dr-gap-x-16 dr-flex-1 dr-justify-end">
      {columnConfig.map((columnId) => (
        <QueueCardAction
          appointment={apt}
          columnId={columnId}
          queueType={rightPanelQueueType}
          key={columnId}
        />
      ))}
    </div>
  );
};

export default ShowConfigSelectedColumns;
